<template>
  <swiper 
    :loop="true"
    :modules="modules" 
    :pagination="{ clickable: true }"
    class="mySwiper">
      <swiper-slide :key="image" v-for="image in images"
        :style="getSliderStyle(image)">
          <div class="camada2"></div>
      </swiper-slide>
  </swiper>
  <div class="titulo">
    <h1 v-html="$t('UMA_LANG_SASUMA_BENVINDO')"></h1>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination } from 'swiper/modules';

export default {
  components:{
    Swiper,
    SwiperSlide,
  },
  props:["images"],
  setup () {
     
    const getSliderStyle = (image) => (
      { backgroundImage: `url('https://www.uma.pt/wp-content/themes/uma/images/sasuma/${image}')` }
    )

    const modules = [Pagination];

    return {
      getSliderStyle,
      modules,
    }
  }
}
</script>

<style>
.mySwiper .swiper-pagination{
  --swiper-pagination-top: 37.7%;
  --swiper-pagination-bottom:0;
  left: 3.5% !important;
  width: auto !important;
  z-index: 20;
  position: absolute;
  transform: translateY(0%);
  z-index: 99;
  display: flex;
  flex-direction: column;
  pointer-events: all !important;
  top: 37.65% !important;
}

@media (max-width: 1024px) {
  .mySwiper .swiper-pagination {
    top: 47% !important;
  }
}

.mySwiper .swiper-pagination-bullet{
  width: 60px;
  height: 4px;
  border-radius: 0;
  display: block;
  margin: .1rem .1rem 20px !important;
  background: rgba(255,255,255,0.35);
  --swiper-pagination-bullet-opacity: 1;
  --swiper-pagination-bullet-inactive-opacity: 1;
}

.mySwiper .swiper-pagination-bullet-active,
.mySwiper .swiper-pagination-bullet:hover{
  background: rgba(255,255,255,1);
  cursor: pointer;
}

@media (max-width: 767px) {
  .mySwiper .swiper-pagination{
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.mySwiper {
  height: 95vh;
  position: relative;
}

@media (max-width: 767px) {
  .mySwiper {
    height: 300px;
  }
}

.mySwiper:before{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: repeating-linear-gradient(-40deg, #12171d, #12051D 1px, #12051D 1px, #12171d 4px);
  opacity: 0.5;
  z-index: 0;
}

.mySwiper .camada2{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: repeating-linear-gradient(-40deg, #12171d, #12051D 1px, #12051D 1px, #12171d 4px);
  opacity: 0.5;
  z-index: 0;
}

.mySwiper .swiper-slide {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  height: 95vh;
  /*max-height: 891px;*/
}

@media (max-width: 767px) {
  .mySwiper .swiper-slide {
    height: 300px;
  }
}

.titulo {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  top: 31.1%;
  text-align: center;
  z-index: 3;
}

.titulo h1 {
  font-family: "Montserrat Bold";
  color: white;
  font-size: 60px;
  margin-bottom: 0px;
  z-index: 3;
  white-space: nowrap;
  display: inline-block;
  opacity: 1;
}

@media (max-width: 1300px) {
  .titulo h1 {
    font-size: 50px;
  }
}

@media (max-width: 1023px) {
  .titulo h1 {
    font-size: 40px;
  }
}

@media (max-width: 767px) {
  .titulo h1 {
    font-size: 20px;
    margin-top: 40px;
  }
}

.swiper-pagination{
  position: absolute;
  top: 40%;
  left: 3.5%;
  transform: translateY(-40%);
  z-index: 99;
  display: flex;
  flex-direction: column;
}

@media (max-width: 767px) {
  .imagem .owlImage{
    height: 300px;
  }

  .imagem .owlImage img{
    display: none;
  }
}

</style>